import { Flex, Button, Tooltip } from 'antd'
import { useCallback, useMemo } from 'react'
import dayjs from 'dayjs'

const downloadContent = (filename, content) => {
  const textContent = content || 'No data available'
  const blob = new Blob([textContent], { type: 'text/plain' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  // Delay revoke to ensure download starts before cleanup
  setTimeout(() => URL.revokeObjectURL(link.href), 100)
}

export const ProfileFooter = ({ prompt, input, model, datetime }) => {
  const formattedDatetime = useMemo(
    () => (datetime ? dayjs(datetime).format('YYYY-MM-DD HH:mm') : '-'),
    [datetime],
  )

  const handleDownloadPrompt = useCallback(() => {
    downloadContent(`prompt-${Date.now()}.md`, prompt)
  }, [prompt])

  const handleDownloadInput = useCallback(() => {
    downloadContent(`input-${Date.now()}.md`, input)
  }, [input])

  return (
    <Flex justify='flex-end' align='center'>
      <Button type='text' onClick={handleDownloadPrompt}>
        ℹ 提示词
      </Button>
      <Button type='text' onClick={handleDownloadInput}>
        📚 参考资料
      </Button>
      <Tooltip title={model}>
        <Button type='text'>{'🕐 ' + formattedDatetime}</Button>
      </Tooltip>
    </Flex>
  )
}
